import React, { createContext, useContext } from 'react';
import { useJsApiLoader, Libraries } from '@react-google-maps/api';
import ServerError from '../components/Error/ServerError';

// 1. Definiamo le costanti di configurazione
const GOOGLE_API_KEY = import.meta.env.VITE_APP_GOOGLE_API_KEY;
const libraries: Libraries = ['maps', 'marker'];

// 2. Definiamo il tipo per il nostro Context
export interface GoogleMapsContextType {
    isLoaded: boolean;
    loadError: Error | undefined;
}

// 3. Creiamo il Context
const GoogleMapsContext = createContext<GoogleMapsContextType | undefined>(undefined);

// 4. Creiamo un hook custom per accedere facilmente al Context
export const useGoogleMaps = () => {
    const context = useContext(GoogleMapsContext);
    if (context === undefined) {
        throw new Error('useGoogleMaps must be used within a GoogleMapsProvider');
    }
    return context;
};

// 5. Creiamo il componente Provider che conterrà la logica
export const GoogleMapsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { isLoaded, loadError } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: GOOGLE_API_KEY || "",
        version: 'weekly',
        libraries: libraries,
        language: 'it',
        region: 'IT'
    });

    if (loadError) {
        return <ServerError message={`Errore critico: impossibile caricare le API di Google Maps. ${loadError.message}`} />;
    }

    return (
        <GoogleMapsContext.Provider value={{ isLoaded, loadError }}>
            {children}
        </GoogleMapsContext.Provider>
    );
};